import React, {useEffect, useMemo} from 'react';
import withStore from "@/hocs/withStore";
import {isDesktop, isDesktopAll} from "@/Helpers/Function";
import Filter from "@/Pages/Catalog/Filter";
import BreadcrumbsCatalog from "@/Pages/Catalog/BreadcrumbsCatalog";
import SortCatalog from "@/Pages/Catalog/SortCatalog";
import CatalogWrap from "@/Pages/Catalog/CatalogWrap";
import H1 from "@/Pages/Catalog/H1";
import Chips from "@/Pages/Catalog/Chips";
import ClearFilter from "@/Pages/Catalog/ClearFilter";
import FiltersModal from "@/Pages/Catalog/FiltersModal";
import "@/Pages/Catalog/scss/index.scss";
import useScrollDirection from "@/Hooks/useScrollDirection";

const IndexCatalog = (props) => {
    const {stores = {}, catalog, allFilter = {}, catalogSort = '', dataSort = []} = props;
    const {filterStore = {}, allStore = {}} = stores;

    useEffect(() => {
        filterStore.sortCatalogControl = catalogSort;
        filterStore.selectedSortingName = dataSort.find(item => item.value === catalogSort)?.name ?? dataSort[0].name;
        filterStore.constructorCatalogStart(catalog, allFilter);
    }, [catalog, allFilter, filterStore, catalog.products]);

    const scrollDirection = useScrollDirection();

    const filter = () => {
        return (
            <div className={`filter`} style={{top: scrollDirection === "down" ? '0px' : allStore.headerHeight + 'px'}}>
                <div className={`container`}>
                    <div className={`filterContainer`}>
                        <Filter {...props} />
                        {isDesktop() && (
                            <div className={`filterContainer__sorting`}>
                                <SortCatalog {...props} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return useMemo(() => (
        <>
            <BreadcrumbsCatalog />
            <section className={`section`}>
                <div className={`container`}>
                    <div className={`catalogTitle`}>
                        <div className={`catalogTitle__left`}>
                            <H1 {...props} />
                        </div>
                        <div className={`cardscrol`}></div>
                    </div>
                </div>
                {filter()}
                {isDesktop() && (
                    <div className={`container`}>
                        <div className={`chips`}>
                            <div className={`chips__sliderContainer`}>
                                <Chips {...props} />
                            </div>
                            <ClearFilter collapse={false} {...props} />
                        </div>
                    </div>
                )}
                <CatalogWrap {...props} />
                <FiltersModal {...props} />
            </section>
        </>
    ), [props, filter]);
}

export default withStore(IndexCatalog)
